/**
 * Consent signal value constants
 */

/**
 * Used when a consent signal has no browser-level support.
 * limitedAdTracking and doNotSell falls into this category — no browser API currently exposes this setting.
 */
export const CONSENT_SIGNAL_UNSUPPORTED = 'unsupported' as const;

export type ConsentSignalUnsupported = typeof CONSENT_SIGNAL_UNSUPPORTED;
